import { render, staticRenderFns } from "./CustomerRiskFactors.vue?vue&type=template&id=136aaf17&"
import script from "./CustomerRiskFactors.vue?vue&type=script&lang=js&"
export * from "./CustomerRiskFactors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports